import React, { useState } from "react";
import PropTypes from "prop-types";
import ModalErrorHandler from "../modals/ModalErrorHandler";
import api from "components/settings/api";

import { Button, Paper, Grid } from "@mui/material";

import withStyles from "@mui/styles/withStyles";
import { makeStyles } from "@mui/styles";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const useStyles = makeStyles((theme) => ({
  modalWrapper: {
    position: "fixed",
    placeContent: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    zIndex: "10002",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#00000098",
    paddingRight: 17,
    "@media screen and (maxWidth: 700)": {
      placeContent: "flex-start",
    },
  },
  containerInner: {
    padding: "20px",
    width: "100%",

    gap: "10px",
  },
  paper: {
    borderRadius: "5px",
    boxShadow: "2.5px 5px #464646",
    maxWidth: "500px",
    width: "400px",
    "@media screen and (max-width: 500px)": {
      width: "90%",
    },
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "24px",
    marginTop: "1rem",
  },
  subtitle: {
    fontFamily: "Open Sans",
    fontWeight: "normal",
    fontSize: 14,
    margin: "0 1rem",
    lineHeight: "150%",
    color: "rgba(0, 27, 17, 0.5)",
  },
  buttons: {
    height: "40px",
    width: "100%",
    borderRadius: "4px",
    color: "#fff",
    backgroundColor: "#e4475b",
    "&:hover": {
      backgroundColor: "#e4475b",
    },
  },
}));

const ReasonModal = ({
  toggleMethod,
  questionText,
  applicantId,
  fetchApplicationData,
}) => {
  const [reasonText, setReasonText] = useState("");

  const classes = useStyles();

  // State updates on input
  const handleInputChange = (event) => {
    const { value } = event.target;

    setReasonText(value);
  };

  // Errors State
  const [showErrors, setShowErrors] = useState(false);
  const [errorsArr, setErrorsArr] = useState();

  // Form submission
  const handleSubmit = async (event) => {
    try {
      if (event) {
        event.preventDefault();
      }

      const payload = {
        reasonText,
        appId: applicantId,
      };

      // Send update for application
      const res = await api.put("/api/v1/invites/decline", payload);

      // If no validation errors were found
      if (res.data.validationErrors === undefined) {
        // Clear any errors
        setErrorsArr([]);
        // Hide the errors component
        setShowErrors(false);
        // Updated data
        fetchApplicationData();
        // Toggle the modal
        toggleMethod();
      } else {
        // Set errors
        setErrorsArr(res.data.validationErrors.errors);
        // Show the errors component
        setShowErrors(true);
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  // If the close (x) is clicked
  const toggleModal = () => {
    toggleMethod();
  };

  return (
    <div className={classes.modalWrapper}>
      <Paper variant="outlined" className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item xxs={10.2} xs={9.4}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <div className={classes.title}>{questionText}</div>
              </Grid>
              <Grid item>
                <Button
                  disableRipple={true}
                  variant="text"
                  className="button--modal_cancelJob"
                  aria-label="Close modal"
                  onClick={toggleModal}
                >
                  <CloseRoundedIcon fontSize="inherit" />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.containerInner}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} sx={{ width: "100%" }}>
            <Grid  direction="column" alignItems="center">
              <form
                className="form--modal_form"
                onSubmit={handleSubmit}
                method="POST"
                aria-label="Decline reason form"
              >
                {showErrors && <ModalErrorHandler errorsArr={errorsArr} />}
                <label className="label--form_label" htmlFor="declineReason">
                  Why is this applicant not a correct fit?
                  <textarea
                    className="input input--form_input input--form_text_area"
                    type="text"
                    name="declineReason"
                    row="10"
                    cols="1"
                    value={reasonText}
                    pattern="^[a-zA-Z,. ]+"
                    onChange={handleInputChange}
                    minLength="1"
                    maxLength="200"
                    required
                    aria-label="Decline reason"
                  />
                </label>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Button className={classes.buttons} type="submit" aria-label="Decline application">
                        Decline Application
                      </Button>
                    </Grid>
                  </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default ReasonModal;

ReasonModal.propTypes = {
  toggleMethod: PropTypes.func,
  questionText: PropTypes.string,
  applicantId: PropTypes.number,
  fetchApplicationData: PropTypes.func,
};
